import { StrictMode, createRoot } from "@wordpress/element";
import GridEntidades from "./GridEntidades";

const root = document.getElementById('content-entidades');
if (root) {
  const displaySearchForm = root.getAttribute('data-display-search-form');
  const filterEntidades = root.getAttribute('data-filter');

  createRoot(root).render(
    <StrictMode>
      <GridEntidades
        filterEntidades={filterEntidades}
        displaySearchForm={displaySearchForm}
      />
    </StrictMode>
  );
}
